import React from "react";
import { Box } from "app/layout/Box/Box";

import "./style.scss";

export type TaboolaConfig = TaboolaFeedConfigObject | { other: "auto" };

export interface TaboolaFeedConfigObject {
    mode: "alternating-thumbnails-a";
    container: string;
    placement: "Below Finance Feed - Video";
    target_type: "mix";
}

function initTaboola() {
    if (typeof window !== "undefined" && typeof window._taboola === "undefined") {
        const _taboola: TaboolaConfig[] = (window._taboola = window._taboola || []);

        _taboola.push({ other: "auto" });

        const script = document.createElement("script");
        script.async = true;
        script.src = "//cdn.taboola.com/libtrc/t-online/loader.js";
        script.id = "tb_loader_script";

        if (window.performance && typeof window.performance.mark === "function") {
            window.performance.mark("tbl_ic");
        }

        document.body.appendChild(script);
    }
}

export const TaboolaFeed = () => {
    React.useEffect(() => {
        initTaboola();

        window?._taboola?.push({
            mode: "alternating-thumbnails-a",
            container: "taboola-below-finance-feed---video",
            placement: "Below Finance Feed - Video",
            target_type: "mix"
        });
    }, []);

    return (
        <Box>
            <div id="taboola-below-finance-feed---video" />
        </Box>
    );
};
